import { AxiosResponse } from 'axios'
import {
  IEntityGST,
  IGenericResponseGST,
  IPaginatedEntityGST
} from 'services/core/genericEntityGST'
import { RequestGST } from 'services/Instances'

export const ContratosServices = () => {
  const path = 'itensAnexados'

  const getByFilter = async (
    params: IPesquisaContratosGetByFilterParams
  ): Promise<AxiosResponse<IPaginatedEntityGST<Iitems[]>>> =>
    await RequestGST.get(path, { params })

  return {
    getByFilter
  }
}

export const ContratoItensSegurancaServices = () => {
  const path = 'itemSegurancaContrato'

  const getItensSegurancaByIdContrato = async (
    idContrato: number
  ): Promise<AxiosResponse<IEntityGST<IContratoItensSegurancaResponse[]>>> =>
    await RequestGST.get(`${path}/GetDocumentacao/${idContrato}`)

  const updateItensSeguranca = async (
    body: IUpdateContratoGSTBody[]
  ): Promise<AxiosResponse<IGenericResponseGST>> =>
    await RequestGST.put(`${path}/UpdateDocumentacao`, body)

  return {
    getItensSegurancaByIdContrato,
    updateItensSeguranca
  }
}

export const ContratoItensSegurancaFiltersServices = () => {
  const path = 'Enumeradores'

  const getItemSegurancaStatusToDictionaryList = async (): Promise<
    AxiosResponse<IEntityGST<IItemSegurancaStatusToDictionaryResponse[]>>
  > => await RequestGST.get(`${path}/ItemSegurancaStatusToDictionary`)

  const getTipoReprovacaoToDictionaryList = async (): Promise<
    AxiosResponse<IEntityGST<ITipoReprovacaoToDictionaryResponse[]>>
  > => await RequestGST.get(`${path}/TipoReprovacaoToDictionary`)

  return {
    getItemSegurancaStatusToDictionaryList,
    getTipoReprovacaoToDictionaryList
  }
}

export const EmpresasServices = () => {
  const path = 'Empresas'

  const getEmpresasList = async (): Promise<
    AxiosResponse<IEntityGST<IEmpresas[]>>
  > => await RequestGST.get(`${path}/Obterlista`)

  return {
    getEmpresasList
  }
}

export const DadosContratoServices = () => {
  const path = 'Contrato'

  const getDadosContrato = async (
    idContrato: number
  ): Promise<AxiosResponse<IEntityGST<IGetDadosContratoResponse>>> =>
    await RequestGST.get(`${path}/GetInfoById/${idContrato}`)

  return {
    getDadosContrato
  }
}

export const CentrosServices = () => {
  const path = 'CentroPlanta'

  const getCentroByEmpresaId = async (
    empresaId: number
  ): Promise<AxiosResponse<ICentroPlantas>> =>
    await RequestGST.get(`${path}/FindByEmpresaId/${empresaId}`)

  const getAllCentroPlantas = async (): Promise<
    AxiosResponse<IEntityGST<IGetAllCentroPlantasResponse>>
  > => await RequestGST.get(`${path}/PopularGrids`)

  return {
    getAllCentroPlantas,
    getCentroByEmpresaId
  }
}

export interface ICentroPlantas extends IGenericResponseGST {
  entity: ICentroPlantasItens[]
}
export interface ICentroPlantasItens {
  idCentroPlanta: number
  txDescricaoCentroPlanta: string
}

export interface IGetAllCentroPlantasResponse {
  comValidacao: IGenericGetALlCentro[]
  semValidacao: IGenericGetALlCentro[]
}
export interface IGenericGetALlCentro {
  idCentroPlanta: number
  empresaId: number
  txDescricaoCentroPlanta: string
  cdCentroCusto: string
  cdCep: string
  cdUF: string
  nuCNAE: string
  nuCNPJ: string
  nuTelefone: string
  txCidade: string
  txEndereco: string
  dtUltimaAtualizaçãoSap: string
  dtAtualizaçãoSap: string
  flNecessitaValidacao: boolean
}

export interface IPesquisaContratosGetByFilterParams {
  empresaId?: number
  centroPlantaId?: number
  documentoStatus?: number
  cdContrato?: string
  cdDocto?: string | number
  nmContraparte?: string
  dtCadastroInicial?: string
  dtCadastroFinal?: string
  nmFornecedor?: string
  itemSegurancaId?: number
  enviarListas?: boolean
  pageNumber?: number
  pageSize?: number
}

export interface IitensAnexadosEntity {
  documentoStatus?: []
  empresas?: IEmpresas[]
  itensSeguranca?: []
  paginatedItens?: IConsultaDocumentosItens<Iitems[]>
}

export interface IConsultaDocumentosItens<T> {
  firstItemOnPage: number
  hasNextPage: boolean
  hasPreviousPage: boolean
  isFirstPage: boolean
  lastItemOnPage: number
  pageCount: number
  pageNumber: number
  pageSize: number
  totalItemCount: number
  items: T
}

export interface Iitems {
  cdContrato: string
  cdDocto: string
  nmContraparte: string
  dtCadastro: string
  documentoStatus: string
  statusDescricao: string
  comAnexo: boolean
  dtAnexo: string
  dtRetorno: string
  idCentroPlanta: number
  idContrato: number
  idContratoExternal: number
  idEmpresa: number
  idFornecedor: number
  idItemAnexado: number
  idItemSegContrato: number
  idItemSeguranca: number
  nmCentro: string
  nmEmpresa: string
  nmFornecedor: string
  nmItemSeguranca: string
  gedExternalId: number
}

export interface IEmpresas {
  empresaId: number
  nmEmpresa: string
}

export interface IGetDadosContratoResponse {
  contratoId: number
  cdContrato: string
  nmFornecedor: string
  cdDocto: string
  nmEmpresa: string
  nmCentroPlanta: string
  dtVigenciaInicio: string
  dtVigenciaFim: string
  dtVigenciaInicioReal: string
  dtVigenciaFimReal: string
  tipoCre: string
  socio: boolean
  objetoDoContrato: string
  nmContraparte: string
  cdMatriculaContraparte: string
}

export interface IContratoItensSegurancaResponse {
  idItemSeguranca: number
  idContrato: number
  idAmrItemSegContrato: number
  nmItemSeguranca: string
  qtPrazo: number
  dtValidade: string
  cdStatusItem: string
  cdReprovado: string
  vlRisco: number
  qtDiasPendentes: number
  txObservacao: string
  nuGedExternalId: number
  subitens: IItensSegurancaSubItens[]
  index?: number
}

export interface IUpdateContratoGSTBody {
  idItemSeguranca: number
  idContrato: number
  cdMatricula: string
  idAmrItemSegContrato: number
  nmItemSeguranca: string
  qtPrazo: number
  dtValidade: string
  cdStatusItem: string
  cdReprovado: string
  vlRisco: number
  qtDiasPendentes: number
  txObservacao: string
  nuGedExternalId: number
  subitens: IItensSegurancaSubItens[]
}

export interface IItensSegurancaSubItens {
  idSubitemSeguranca: number
  idItemSeguranca?: number
  idSubitemNaoConforme?: number
  nuItemGrid: number
  txDescricaoSubitem: string
  flOk: boolean
  cdInfracao: string
  qtUfir: number
  vlTotal: number
}
export interface IItemSegurancaStatusToDictionaryResponse {
  codigoDeStatus: string
  descricaoDoStatus: string
}

export interface ITipoReprovacaoToDictionaryResponse {
  tipoReprovacaoCodigo: string
  tipoReprovacaoDescricao: string
}
